function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import PageComponent from '../base/PageComponent';
import GLightbox from 'glightbox';
import Shuffle from 'shufflejs';
var Portfolio = /*#__PURE__*/function (_PageComponent) {
  _inherits(Portfolio, _PageComponent);
  var _super = _createSuper(Portfolio);
  function Portfolio() {
    _classCallCheck(this, Portfolio);
    return _super.apply(this, arguments);
  }
  _createClass(Portfolio, [{
    key: "init",
    value: function init() {
      this.ready();
    }
  }, {
    key: "ready",
    value: function ready() {
      this.shuffle();
    }
  }, {
    key: "shuffle",
    value: function shuffle() {
      var top = this;

      // check url for filter param
      var url_string = window.location.href;
      var url = new URL(url_string);
      var filterParam = url.searchParams.get("category");

      // initialize ShuffleJS
      var shuffleInstance = new Shuffle(document.getElementById('shuffleList'), {
        itemSelector: '.js-portfolio-item',
        sizer: '.js-shuffle-sizer'
      });
      window['portfolio-layout'] = shuffleInstance;

      // if url filter param, filter list
      if (filterParam && filterParam.length > 0) {
        if (shuffleInstance) {
          shuffleInstance.filter(filterParam);

          // update frontend buttons to reflect filter option
          $('.portfolio__category').each(function (index, ele) {
            $(this).removeClass('active');
          });
          $('.portfolio__category[data-category=' + filterParam + ']').addClass('active');
        }
      }

      // on shuffle layout change (including first load)
      shuffleInstance.on(Shuffle.EventType.LAYOUT, function () {
        // destroy existing lightbox
        if (lightbox) {
          lightbox.destroy();
        }

        // reinitialize lightbox
        var lightbox = GLightbox({
          selector: 'shuffle-item--visible',
          touchNavigation: true
        });
      });

      // Category click event
      $('.portfolio__category').on('click', function (e) {
        var selected = $(this).data('category');
        if (selected) {
          if (selected === 'all') {
            shuffleInstance.filter(Shuffle.ALL_ITEMS);
          }

          // if != 'all'
          shuffleInstance.filter(selected);

          // Set active state for Categories
          top.setCategory(selected);
        }
      });
    }
  }, {
    key: "setCategory",
    value: function setCategory(selected) {
      var selected = selected;
      $('.portfolio__category').each(function (index, ele) {
        $(ele).removeClass('active');
        if ($(ele).data('category') === selected) {
          $(ele).addClass('active');
        }
      });
    }
  }]);
  return Portfolio;
}(PageComponent);
export { Portfolio as default };